import { type PermissionRouteData, PermissionRoute } from '@exam-management/permission-route';
import { APP_PERMISSIONS } from '@exam-management/permissions';
import { useParams } from '@exam-management/router';

export default function QSetDetailsRouteController() {
  const { courseId, qSetId } = useParams('/exam-courses/:courseId/qsets/:qSetId');
  const defaultRoutes: PermissionRouteData[] = [
    {
      path: '/exam-courses/:courseId/qsets/:qSetId/details',
      requiredPermission: [APP_PERMISSIONS.EXAM.QSET.VIEW],
      params: {
        courseId,
        qSetId,
      },
    },
    {
      path: '/exam-courses/:courseId/qsets/:qSetId/activity-log',
      requiredPermission: [APP_PERMISSIONS.EXAM.AUDIT_LOG.VIEW],
      params: {
        courseId,
        qSetId,
      },
    },
  ];

  return <PermissionRoute routes={defaultRoutes} />;
}
